import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import { Box, Collapse, IconButton } from '@mui/material';
import { GoogleMap, MarkerF } from '@react-google-maps/api';
import React, { useState } from 'react';
import { Palette } from 'Palette';
import { RADIUS } from 'DesignTokens';
import StyledModal from '../../styles/StyledModal';

export default function AddressMapPreview({
  lat,
  lng,
  fullAddress,
  open,
}: {
  lat: number;
  lng: number;
  fullAddress: string;
  open: boolean;
}) {
  const [modalOpen, setModalOpen] = useState(false);
  return (
    <>
      <Collapse in={open}>
        <Box
          sx={{
            mt: 1.5,
            position: 'relative',
            borderRadius: RADIUS.sectionChild,
            overflow: 'hidden',
            border: `1px solid ${Palette.default.border}`,
          }}
        >
          <GoogleMap
            mapContainerStyle={{ width: '100%', height: '160px' }}
            center={{ lat, lng }}
            zoom={15}
            options={{
              disableDefaultUI: true,
              gestureHandling: 'none',
              keyboardShortcuts: false,
              clickableIcons: false,
            }}
          >
            <MarkerF position={{ lat, lng }} />
          </GoogleMap>
          <IconButton
            size="small"
            onClick={() => setModalOpen(true)}
            sx={{
              position: 'absolute',
              top: 8,
              right: 8,
              backgroundColor: '#FFFFFF',
              boxShadow: '0 1px 3px rgba(15,23,42,0.2)',
              '&:hover': { backgroundColor: '#FFFFFF' },
            }}
          >
            <OpenInFullIcon fontSize="small" />
          </IconButton>
        </Box>
      </Collapse>
      <StyledModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        title={fullAddress}
        maxWidth="sm"
        fullWidth
      >
        <GoogleMap
          mapContainerStyle={{ width: '100%', height: '400px' }}
          center={{ lat, lng }}
          zoom={16}
        >
          <MarkerF position={{ lat, lng }} />
        </GoogleMap>
      </StyledModal>
    </>
  );
}
